export default function typeofOrNull(thing) {
    return thing === null ? 'null' : typeof thing;
}
